import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperOverviewPage } from './shopper-overview';

@NgModule({
  declarations: [
    ShopperOverviewPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperOverviewPage),
    TranslateModule.forChild()
  ],
})
export class ShopperOverviewPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-overview/shopper-overview.module.ts